// extracted by mini-css-extract-plugin
module.exports = {"logo":"TopBar_logo__3pe6W","breadcrumbs":"TopBar_breadcrumbs__2_9kJ"};